import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { Subscription } from "rxjs";
import { BaseServiceService } from "../../services/base-service.service";

declare var fabric: any;

export const ModalNotifyTypes = {
  Success: {
    Id: 1,
    Icon: "ms-Icon ms-Icon--SkypeCircleCheck",
    Image: "",
    Class: "success",
  },
  Info: { Id: 2, Icon: "ms-Icon ms-Icon--InfoSolid", Image: "", Class: "info" },
  Warning: {
    Id: 3,
    Icon: "ms-Icon ms-Icon--WarningSolid",
    Image: "",
    Class: "warning",
  },
  Danger: {
    Id: 4,
    Icon: "ms-Icon ms-Icon--StatusErrorFull",
    Image: "",
    Class: "danger",
  },
  Primary: { Id: 5, Icon: "", Image: "", Class: "primary" },
  Secondary: { Id: 6, Icon: "", Image: "", Class: "secondary" },
  Light: {
    Id: 6,
    Icon: "ms-Icon ms-Icon--QuickNoteSolid",
    Image: "",
    Class: "light",
  },
  Dark: {
    Id: 6,
    Icon: "ms-Icon ms-Icon--QuickNoteSolid",
    Image: "",
    Class: "dark",
  },
  Link: { Id: 6, Icon: "ms-Icon ms-Icon--Link", Image: "", Class: "link" },
  Question: {
    Id: 7,
    Icon: "ms-Icon ms-Icon--UnknownSolid",
    Image: "",
    Class: "primary",
  },
  QuestionWarning: {
    Id: 8,
    Icon: "ms-Icon ms-Icon--UnknownSolid",
    Image: "",
    Class: "warning",
  },
  QuestionDanger: {
    Id: 9,
    Icon: "ms-Icon ms-Icon--UnknownSolid",
    Image: "",
    Class: "danger",
  },
};

@Component({
  selector: "app-modal-notify",
  templateUrl: "./modal-notify.component.html",
  styleUrls: ["./modal-notify.component.scss"],
})
export class ModalNotifyComponent implements OnInit, OnDestroy {
  @Output() actionConfirmed: EventEmitter<boolean> = new EventEmitter<boolean>();

  titulo: string = "";
  internalDescription: string = "";
  modalNotifyType: any = ModalNotifyTypes;
  ok: string = "Aceptar";
  viewOk: boolean = true;
  isDelete: boolean = false;
  modalNotifyElem: any;
  private isModalOpen: boolean = false; // Bandera para controlar el estado del modal
  private modalSubscription: Subscription; // Variable para almacenar la suscripción

  constructor(private baseService: BaseServiceService) {}

  ngOnInit(): void {
    this.modalSubscription = this.baseService.showModal$.subscribe(
      ({ titulo, descripcion, modalNotifyType, isDelete }) => {
        this.show(titulo, descripcion, modalNotifyType, isDelete);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }

  show(
    titulo: string,
    descripcion: string,
    modalNotifyType: any,
    isDelete: boolean
  ) {
    const dialog = document.querySelector(".ms-Dialog-Notify");
    this.modalNotifyElem = new fabric["Dialog"](dialog);

    this.titulo = titulo;
    this.internalDescription = descripcion;
    this.modalNotifyType = modalNotifyType;
    this.isDelete = isDelete;

    this.modalNotifyElem.open();
  }

  close(): void {
    this.modalNotifyElem.close();
  }

  confirmAction(confirmed: boolean): void {
    this.actionConfirmed.emit(confirmed); // Emite el resultado del modal
    this.modalNotifyElem.close();
  }
}

